import { useSyncExternalStore } from 'react';
import { openRequestCount } from '../lib/openRequestCount';

// The notifications poll and the Requests page both write the count; the sidebar only reads it.
export function useOpenRequestCount(): number | null {
  return useSyncExternalStore(openRequestCount.subscribe, openRequestCount.get);
}
